var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpandChevron(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline/expand-chevron"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.728 10.104L12 1.68L1.272 10.104C1.128 10.216 0.952 10.272 0.744 10.272C0.536 10.272 0.36 10.216 0.216 10.104C0.072 9.992 0 9.856 0 9.696C0 9.52 0.072 9.376 0.216 9.264L12 0L23.784 9.264C23.928 9.376 24 9.52 24 9.696C24 9.856 23.928 9.992 23.784 10.104C23.64 10.216 23.464 10.272 23.256 10.272C23.048 10.272 22.872 10.216 22.728 10.104ZM1.272 13.896L12 22.32L22.728 13.896C22.872 13.768 23.048 13.704 23.256 13.704C23.464 13.704 23.64 13.768 23.784 13.896C23.928 14.008 24 14.144 24 14.304C24 14.464 23.928 14.6 23.784 14.712L12 24L0.216 14.712C0.072 14.6 0 14.464 0 14.304C0 14.144 0.072 14.008 0.216 13.896C0.36 13.768 0.536 13.704 0.744 13.704C0.952 13.704 1.128 13.768 1.272 13.896Z",
    fill: "#474747"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandChevron);
export default __webpack_public_path__ + "static/media/expand-chevron.8b9144d3f04cb5f69489e323df6dd64b.svg";
export { ForwardRef as ReactComponent };